import { Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { RacesComponent } from './pages/races/races.component';
import { RaceDetailComponent } from './pages/race-detail/race-detail.component';
import { RankingsComponent } from './pages/rankings/rankings.component';
import { HumanProfileComponent } from './pages/human-profile/human-profile.component';
import { DogProfileComponent } from './pages/dog-profile/dog-profile.component';
import { MyProfileComponent } from './pages/my-profile/my-profile.component';
import { ClubsComponent } from './pages/clubs/clubs.component';
import { ImportRankingComponent } from './pages/import-ranking/import-ranking.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { CompareProfilesComponent } from './pages/compare/compare-profiles.component';
import { ClubProfileComponent } from './pages/club-profile/club-profile.component';

import { AdminDashboardComponent } from './pages/admin/dashboard/admin-dashboard.component';
import { AdminClubsComponent } from './pages/admin/clubs/admin-clubs.component';
import { AdminDogsComponent } from './pages/admin/dogs/admin-dogs.component';
import { AdminCategoriesComponent } from './pages/admin/categories/admin-categories.component';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';

export const routes: Routes = [
    { path: '', redirectTo: 'races', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'forgot-password', loadComponent: () => import('./pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent) },
    { path: 'reset-password', loadComponent: () => import('./pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent) },
    { path: 'races', component: RacesComponent },
    { path: 'race-detail/:id', component: RaceDetailComponent },
    { path: 'rankings', component: RankingsComponent },
    { path: 'human-profile/:id', component: HumanProfileComponent },
    { path: 'dog-profile/:id', component: DogProfileComponent },
    { path: 'compare/human', component: CompareProfilesComponent },
    { path: 'compare/human/:id1', component: CompareProfilesComponent },
    { path: 'compare/human/:id1/:id2', component: CompareProfilesComponent },
    { path: 'clubs', component: ClubsComponent },
    {
        path: 'courses',
        loadComponent: () => import('./pages/courses/courses.component').then(m => m.CoursesComponent)
    },
    // Former second detail page of an event, merged into race-detail: keep old links working.
    { path: 'courses/:id', redirectTo: 'race-detail/:id' },
    { path: 'club-profile/:clubName', component: ClubProfileComponent },

    {
        path: '',
        canActivate: [authGuard],
        children: [
            { path: 'dashboard', component: DashboardComponent },
            { path: 'my-profile', component: MyProfileComponent },
            { path: 'feedback', loadComponent: () => import('./pages/feedback/feedback.component').then(m => m.FeedbackComponent) }
        ]
    },

    {
        path: 'admin',
        canActivate: [adminGuard],
        children: [
            { path: 'dashboard', component: AdminDashboardComponent },
            { path: 'stats', loadComponent: () => import('./pages/data-stats/data-stats.component').then(m => m.DataStatsComponent) },
            { path: 'site-notice', loadComponent: () => import('./pages/admin/site-notice/site-notice.component').then(m => m.SiteNoticeComponent) },
            { path: 'clubs', component: AdminClubsComponent },
            { path: 'dogs', component: AdminDogsComponent },
            { path: 'categories', component: AdminCategoriesComponent },
            { path: 'import-ranking', component: ImportRankingComponent },
            { 
                path: 'ffslc-races', 
                loadComponent: () => import('./pages/admin/ffslc-races/ffslc-races.component').then(m => m.AdminFfslcRacesComponent) 
            },
            { 
                path: 'recuperation-evenements', 
                loadComponent: () => import('./pages/admin/recuperation-evenements/recuperation-evenements.component').then(m => m.RecuperationEvenementsComponent) 
            },
            {
                path: 'resultats',
                loadComponent: () => import('./pages/admin/resultats-list/resultats-list.component').then(m => m.ResultatsListComponent)
            },
            {
                path: 'resultats/:id',
                loadComponent: () => import('./pages/admin/resultats-course/resultats-course.component').then(m => m.ResultatsCourseComponent)
            },
            {
                path: 'regions',
                loadComponent: () => import('./pages/admin/regions/admin-regions.component').then(m => m.AdminRegionsComponent)
            },
            {
                path: 'staging',
                loadComponent: () => import('./pages/admin/staging/staging.component').then(m => m.StagingComponent)
            },
            {
                path: 'staging/:id',
                loadComponent: () => import('./pages/admin/staging/staging-detail.component').then(m => m.StagingDetailComponent)
            },
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
        ]
    },

    { path: '**', redirectTo: 'races' }
];
